export default __webpack_public_path__ + "static/media/about_img6.135ded2a.svg";